<ul class="footer-space">
  <li>
    <a class="footer-item-link" routerLink="/terms-of-use" target="_blank">
      {{ 'footer.term_of_use' | translate }}
    </a>
  </li>

  <li>
    <a class="footer-item-link" href="{{ 'footer.url_privacy_protection' | translate }}"
      onClick="s_objectID='footer:Datenschutz:External link';" target="_blank">
      {{ 'footer.privacy_protection' | translate }}
    </a>
  </li>

  <li>
    <a class="footer-item-link" href="{{ 'footer.url_legal_info' | translate }}"
      onClick="s_objectID='footer:Impressum:External link';" target="_blank">
      {{ 'footer.legal_info' | translate }}
    </a>
  </li>

  <li>
    <a class="footer-item-link" href="#" onclick="OneTrust.ToggleInfoDisplay();return false;">
      {{ 'footer.cookie_dialog' | translate }}
    </a>
  </li>

</ul>
